import classnames from "classnames";
import { ScrollableTable, TableColumnProps } from "Components/ScrollableTable/ScrollableTable";
import { I18N_NS } from "Config/i18n";
import { withTranslation, WithTranslation } from "react-i18next";
import {
  EmailListItemAddress,
  EmailListItemAttach,
  EmailListItemDate,
  EmailListItemPrio,
  EmailListItemSubject,
} from "../DefaultLayout/EmailListItem";

interface EmailSearchResultTableProps extends WithTranslation {
  data: API_MailResponse[];
  onRowClick: (id: string) => void;
  addressKey: "to" | "from";
  onSelectItem: (items: string[], emails: API_MailResponse[]) => void;
  selectedItems: string[];
}

export const EmailSearchResultTable = withTranslation(I18N_NS.PROJECT)(
  ({ t, data, onRowClick, selectedItems, addressKey, onSelectItem }: EmailSearchResultTableProps) => {
    const isSelectedRow = (id) => {
      return selectedItems.some((selectedId) => selectedId === id);
    };

    const columns: TableColumnProps<API_MailResponse>[] = [
      {
        dataKey: "from",
        label: t("From"),
        width: 300,
        flexShrink: 1,
        disableSort: true,
        cellRenderer: ({ rowData }) => (
          <div>
            <EmailListItemAddress
              address={rowData[addressKey]}
              cc={rowData.cc}
              bcc={rowData.bcc}
              correspondents={rowData.correspondents}
            />
          </div>
        ),
      },
      {
        dataKey: "importance",
        disableSort: true,
        label: t("Prio"),
        width: 60,
        // flexShrink: 0,
        cellRenderer: ({ rowData }) => <EmailListItemPrio importance={rowData.importance} />,
      },
      {
        dataKey: "subject",
        label: t("Subject"),
        width: 150,
        flexGrow: 1,
        flexShrink: 1,
        cellRenderer: ({ rowData }) => <EmailListItemSubject excerpt={rowData.excerpt} subject={rowData.subject} />,
      },
      {
        dataKey: "hasAttachments",
        label: t("Attachments"),
        width: 100,
        cellRenderer: ({ rowData }) => (
          <div>
            <EmailListItemAttach hasAttachments={rowData.hasAttachments} />
          </div>
        ),
      },
      {
        dataKey: "timestamp",
        label: t("Date"),
        width: 160,
        cellRenderer: ({ rowData }) => <EmailListItemDate timestamp={rowData.timestamp} />,
      },
    ];

    return (
      <ScrollableTable<API_MailResponse>
        rowKey="id"
        columns={columns}
        data={data}
        defaultSortBy={"timestamp"}
        defaultSortDirection={"DESC"}
        onSelectRows={({ selectedRowKeys, selectedRows }) => onSelectItem(selectedRowKeys as string[], selectedRows)}
        onRowClick={({ rowData }) => onRowClick(rowData.id)}
        rowClassName={(rowData) =>
          classnames("email-item", { active: rowData.unread, selected: isSelectedRow(rowData.id) })
        }
        resizeableHeaders={"EMAIL_SEARCH"}
        ignoreResizeableHeaders={["id"]}
      />
    );
  }
);
